import { experimentVariants } from "@clockwise/web-commons/src/util/local-storage";
import { getAnalyticsId } from "@clockwise/web-commons/src/util/analytics.util";
import { toHashCode } from "@clockwise/client-commons/src/util/hash";

////////////////////////
// Active Experiments
////////////////////////
enum ExperimentKey {
  LinkSchedulerConfirmationSignupBanner = "LinkSchedulerConfirmationSignupBanner",
}

////////////////////////
// Local Storage Helpers
////////////////////////
function setExperimentVariant<VariantType>(experimentKey: ExperimentKey, variant: VariantType) {
  experimentVariants.set(experimentKey, variant);
}

function getExperimentVariant<VariantType>(experimentKey: ExperimentKey): VariantType {
  return experimentVariants.get(experimentKey);
}

////////////////////////
// Experiment Variants
////////////////////////

// Link Scheduler Confirmation Page - Signup
export enum LinkSchedulerConfirmationSignupBannerVariant {
  Control = "Control",
  GoogleAuth = "GoogleAuth",
  EmailForm = "EmailForm",
}

export function setLinkSchedulerConfirmationSignupBannerVariant() {
  const variants = Object.keys(
    LinkSchedulerConfirmationSignupBannerVariant,
  ) as LinkSchedulerConfirmationSignupBannerVariant[];

  const bucketIndex = Math.abs(toHashCode(getAnalyticsId()) % variants.length);

  setExperimentVariant(ExperimentKey.LinkSchedulerConfirmationSignupBanner, variants[bucketIndex]);
}

export function getLinkSchedulerConfirmationSignupBannerVariant(): LinkSchedulerConfirmationSignupBannerVariant {
  return getExperimentVariant(ExperimentKey.LinkSchedulerConfirmationSignupBanner);
}
